import styled from 'styled-components/macro';
import Typography from '@material-ui/core/Typography';

const Headline1 = styled(Typography).attrs({
  variant: 'h1',
  component: 'h2',
})`
text-align: left;
`;

export default Headline1;
